<template>
	<v-btn
			class="rounded"
			:class="{
				'v-btn--active': editor.isFocused && editor.isActive('orderedList')
			}"
			:color="editor.isFocused && editor.isActive('orderedList') ? 'primary' : 'transparent'"
			depressed
			fab
			small
			@click="editor.chain().focus().toggleOrderedList().run()"
			@mousedown.stop.prevent
	>
		<v-icon>
			mdi-format-list-numbered
		</v-icon>
	</v-btn>
</template>

<script>
export default {
	name: 'OrderedList',
	props: {
		editor: Object
	}
}
</script>

<style lang="scss" scoped>
.v-btn {
	transition-duration: 0.28s;
	transition-property: background-color, box-shadow, color, transform, opacity;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
</style>